// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		//Call function with browser is resized.
		/* $(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow(); */

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function () {
		// 	$(this).addClass("hover");
		// 	$('ul.submenu', this).fadeIn(200);
		// }, function () {
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu', this).fadeOut(200);
		// });

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
		scrollW();


		//function wrapper text
		//get cms string

		const btnHamilton = document.querySelectorAll(".cmsText");
		btnHamilton.forEach(function (value, key) {

			var cmsText = value.innerHTML;
			//separe words
			cmsText = cmsText.split(" ");

			//get last words
			var lastWord = cmsText[cmsText.length - 1];

			//separe letters
			lastWord = lastWord.split("");
			var newLastWord = "";

			//concat all letters and add span with class "white-on-hover" before last 6 letters
			for (let i = 0; i < lastWord.length; i++) {
				if (i == lastWord.length - 4) {
					newLastWord += '<span class="white-on-hover">';
					newLastWord += lastWord[i];
				} else if (i == lastWord.length - 1) {
					newLastWord += lastWord[i];
					newLastWord += "</span>";
				} else {
					newLastWord += lastWord[i];
				}
			}

			//concat all words adding the new last word
			var newCmsText = "";
			for (let i = 0; i < cmsText.length; i++) {
				if (i != cmsText.length - 1) {
					newCmsText += cmsText[i];
					newCmsText += " ";
				} else {
					newCmsText += newLastWord;
				}
			}

			//change the text for new text
			value.innerHTML = newCmsText;

		})

		// end function
	};

	//single form page no header or footer
	if(document.getElementById('single-form')){
		document.getElementById('header').style.display = 'none'
		document.getElementsByClassName('footer')[0].style.display = 'none'
		document.getElementsByClassName('site-border-right')[0].style.display = 'none'
		document.getElementsByClassName('site-border-left')[0].style.display = 'none'
	}


}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling


	// Find class for open fancybox in single quad
	let openfancy = document.querySelectorAll(".openfancybox");
	if (openfancy.length != 0) {	
		openfancy[0].setAttribute("data-fancybox", openfancy);
	}

}


// Booking
$(document).ready(function () {
	var start = $("#arriveInput").attr("value");
	var end = $("#departureInput").attr("value");
	var firstClick = 0;
	var limitDate = $("#limitDate").attr("value").split(",");
	$("#datesCalendar").datepicker({
		minDate: start,
		numberOfMonths: 2,
		dateFormat: "mm/dd/yy",
		maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
		beforeShowDay: function (date) {
			$.datepicker._defaults.dateFormat = "mm/dd/yy";
			var startDate = $.datepicker.parseDate("mm/dd/yy", start);
			var endDate = $.datepicker.parseDate("mm/dd/yy", end);

			if (date.getTime() == startDate.getTime()) {
				return [true, "start-day"];
			} else {
				if (date.getTime() == endDate.getTime()) {
					return [true, "end-day"];
				} else {
					if (
						date.getTime() > startDate.getTime() &&
						date.getTime() < endDate.getTime()
					) {
						return [true, "days"];
					} else {
						return [true, ""];
					}
				}
			}
		},
		onSelect: function (date) {
			var selectedDate = $.datepicker.parseDate(
				$.datepicker._defaults.dateFormat,
				date
			);

			if (firstClick == 0) {
				start = date;
				end = date;
				firstClick = 1;
			} else {
				if (selectedDate <= start) {
					end = start;
					start = date;
				} else {
					end = date;
				}
				firstClick = 0;
			}
			let arrayStartDate = start.split('/');
			let startDay = `${arrayStartDate[2]}-${arrayStartDate[0]}-${arrayStartDate[1]}`
			let arrayEndtDate = end.split('/');
			let endDay = `${arrayEndtDate[2]}-${arrayEndtDate[0]}-${arrayEndtDate[1]}`
			console.log(startDay);
			console.log(endDay);

			$("#arriveInput").attr("value", startDay);
			$("#departureInput").attr("value", endDay);
			console.log(
				"Selected date: " + startDay + "; input's current value: " + endDay
			);
			$("#pickup").val(start + "   -   " + end);
		},
		onChangeMonthYear: function () {
			setTimeout(function () {
				calendarH();
			}, 80);
		},
	});
	var booking_date_format = "yy/mm/dd";
	var booking_min_date = "";
	var booking_allow_children = false;
	$("#pickup").mask("Z9-Z9-9999   -   Z9-Z9-9999", {
		translation: {
			Z: {
				pattern: /[0-9]/,
				optional: true,
			},
		},
	});

});
// End Booking